/**
 * WizardFooter — Tilbake / Neste nederst i Oppsett (#159, steg 9f).
 *
 * Skissen har Tilbake (sekundær, 1 del) og Neste (primær, 2 deler), 56 px
 * høye. Footeren står nederst i trinnet (`mt-auto`), ikke festet over
 * innholdet: medlemssteget er langt, og en fast footer ville dekket feltene
 * over seg. Steg 1 har ikke noe å gå tilbake til og sender ingen `onBack`.
 *
 * Neste er barnet, fordi hvert trinn har sin egen handling og testid
 * (`continue`, `finish-family`, `finish`).
 */
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../components/primitives/Button';

interface WizardFooterProps {
  onBack?: () => void;
  /** Tilbake vises, men er sperret (f.eks. mens noe lagres). */
  backDisabled?: boolean;
  /** Kort forklaring over knappene, f.eks. hvorfor Neste er grå. */
  hint?: ReactNode;
  children: ReactNode;
}

export function WizardFooter({ onBack, backDisabled = false, hint, children }: WizardFooterProps) {
  const { t } = useTranslation();
  return (
    <div className="mt-auto flex flex-col gap-2 pt-2 pb-8" data-testid="wizard-footer">
      {hint}
      <div className="flex gap-2.5">
        {onBack ? (
          <Button
            variant="secondary"
            size={56}
            className="flex-1"
            disabled={backDisabled}
            onClick={onBack}
            data-testid="onboarding-back"
          >
            {t('common.back')}
          </Button>
        ) : null}
        {children}
      </div>
    </div>
  );
}
